export class NoFilesAvailableError extends Error {}
export class NoProfilesError extends Error {}
